<template>
  <div class="container">
  <router-link to="/live/test">Test</router-link>
    <router-link to="/live/testdfsdfsdf">   Test not working</router-link>
      <router-link to="/live/test/lsk">   Test Bad Answer</router-link>


 <div v-if="listQuestion">
<h1>{{listQuestion.details.title}}</h1>
<h2 v-if="listQuestion.details.tag">{{listQuestion.details.tag}}</h2>
</div>
<hr/>

<div v-if="viewQuestion"><h2>{{listQuestion.question}}</h2>
<div class="row">
 <div class="col-sm-3 container">
<div v-for="a in listChoices" :key=a.id>
    <router-link :to="{name: 'live', params:{answer: a.id}}">
      <!-- {{a.letter}}) {{a.name}} -->
      <button  type="button" class="btn btn-info btn-block">{{a.name}}</button>
      </router-link><br/>
    </div>
 </div></div>
</div>
<div v-if="viewAnswer"> 
  <!-- <h2>{{uQuestion}}</h2> -->
<h2>{{listQuestion.question}}</h2>
<div v-for="a in listChoices" :key=a.id>{{a.name}}
</div>
  <h3>Thanks, we have your answer to the question.</h3>
  <strong> You selected {{listQuestion.choices[userAnswer.choice].name}}</strong>
  <h3>We will reveal the correct answer after the commercial break</h3>

</div>
  <div v-if="noQuiz">No Quiz at this address</div>

  </div>
</template>

<script>
import db from '../../../lib/db'
import orderby from 'lodash/orderBy'
export default {
  name: 'LiveQuestion',
  props: {
    msg: String
  },
  data(){
      return {
          viewAnswer: null,
          viewQuestion: null,
          noQuiz: null,
          listQuestion: '',
          uAnswer: '',
          uQuestion: '',
          curruser: null,
          userAnswer: null,
          }
  },
  methods: {
    showQuestion: function(v1,v2,v3) {
      this.viewAnswer = v1
      this.noQuiz = v2
      this.viewQuestion = v3
    },
    isQuiz: function () {
      return this.getQuestion().then((stat) => {
        if(stat) {
          console.log('stat us ', stat)
        }
        else {
          console.log('we donnt live here ')
        }
        return stat
      })
    },
    getQuestion: function (path,lang) {
          return db.getRef().ref('live').child(this.$route.params.liveid).once('value').then((snapshot) => {
    if(snapshot.exists()){    
    console.log('snap ', snapshot.val())
        this.listQuestion = snapshot.val()
      
        // this.showQuestion(false,false,true) 
    }
    else{
      this.listQuestion = null
      console.log('show an erorr or something')
      this.showQuestion(false,true,false)
    }
    return snapshot.exists()
          })
      },
      showOptions: function() {
          console.log('show me options')
          this.getQuestion().then((stat) => {
            console.log('lslslslslsl ',stat)
            if(stat)
            {
               this.showQuestion(false,false,true)
            }
            else {
               this.showQuestion(false,true,false)
            }
          })
      },
      submitAnswer: function () {
        return db.getRef().ref('liveresults').child(this.$route.params.liveid)
        .child(this.curruser.uid).set({
          "stamp": Date.now(),
          "choice": this.$route.params.answer,
          "submitted": true
        })
        //add error catching
        },
      hasAnswered: function () {
        return db.getRef().ref('liveresults').child(this.$route.params.liveid)
        .child(this.curruser.uid).once('value').then((snapshot)=> {
          console.log('has answered value ', snapshot.exists())
          return snapshot.exists()
        })
      },

      // },
      showAnswered: function() {
        this.getQuestion().then(() =>{
          this.getAnswer().then(() => {
            this.showQuestion(true,false,false)

          })
        })
      },
      showAnswer: function(){
            return db.getRef().ref('live').child(this.$route.params.liveid)
            .once('value').then((snapshot) => {
              console.log('snapppp ', snapshot.child('choices').child(this.$route.params.answer).val())
              if(snapshot.child('choices').child(this.$route.params.answer).exists()){
                this.submitAnswer().then(()=> {
                this.uQuestion = snapshot.child('question').val()
                this.uAnswer = snapshot.child('choices').child(this.$route.params.answer).val()
                console.log('submit this as the users answer')
                }).then(() =>{
                    this.showAnswered()
                    console.log('at this point, i need to refresh the view')
                })
                
               

              }
              else {
                console.log('make the user pick an answer')
                this.$router.push({ name: 'live', params: { liveid: this.$route.params.liveid } })

              }
            })

      },
      refreshView: function() {
            if(this.$route.params.answer == undefined){
          console.log('no answer provided, show questions ') 
          this.showOptions()    
          this.isSubmitted()

      }
      else{
          this.showAnswer()

      } 
      },
      getAnswer: function () {
          return db.getRef().ref('liveresults').child(this.$route.params.liveid)
        .child(this.curruser.uid)
            .once('value').then((snapshot) => {
              this.userAnswer = snapshot.val()
              return snapshot.exists()

            })
      },
      isSubmitted: function() {
        return db.getRef().ref('liveresults').child(this.$route.params.liveid)
        .child(this.curruser.uid)
            .once('value').then((snapshot) => {
              console.log('snapyy ', snapshot.val())
              return snapshot.exists()

            })
  },
      initQuiz: function () {
         this.isQuiz().then((active)=>{
      if(active) {
         this.liveLogin().then((user) => {
         console.log('initQuiz user ', user)
          this.initAnswer()
        })
      }
      else {
        this.showQuestion(false,true,false)
      }
    })
      },
      initAnswer: function () {
    
        this.hasAnswered().then((answered)=> {
          if(answered){
          console.log('i already answered this, show my answer ')
          this.showAnswered()
            }
            else {
              console.log('I aint answered yet')
              this.refreshView()
            }
          })
      },
      liveLogin: function () {
       return db.anonAuth().then((user) => {
          console.log('anon credentia ', user.user.uid)
          this.curruser = user.user
          return user
        }) 
      }
  },
  computed: {
  listChoices: function () {
    return orderby(this.listQuestion.choices, 'letter')
  }
},
  created(){
    // db.signOut()
    this.initQuiz()
    // this.isQuiz().then((active)=>{
    //   if(active) {
    //      this.liveLogin().then((user) => {
    //        console.log('uuuu ', user)
    //       this.initAnswer()
    //     })
    //   }
    //   else {
    //     this.showQuestion(false,true,false)
    //   }
    // })
   
   },
   watch: {
    $route(to, from) {
      // react to route changes...
      this.initQuiz()

    }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
